
import Vue from "vue";
import { Prop, Component, Watch } from "vue-property-decorator";

@Component
export default class MultiInputField extends Vue {
  localValue = [""];

  @Prop({ default: "name" })
  name: string;

  @Prop({ default: [""] })
  value: Array<string>;

  @Prop({ default: "displayName" })
  placeholder: string;

  @Prop({ default: true })
  type: boolean;

  @Prop({ default: "" })
  customClass: string;

  @Prop({ default: null })
  error: Object;

  @Prop({ default: false })
  disabled: boolean;

  @Prop({ default: null })
  min: number;

  @Prop({ default: false })
  autofocus: boolean;

  @Prop({ default: null })
  step: string;

  @Prop({ default: true })
  showClear: boolean;

  mounted() {
    this.localValue = this.value;
  }
  get classObject() {
    return this.customClass;
  }

  get refName() {
    return `${this.name}_input`;
  }

  @Watch("value")
  valueChanged(val) {
    this.localValue = val;
  }

  update(val) {
    this.$emit("input", val);
  }

  reset() {
    this.localValue = [""];
  }
}
